export default class Images {

    logo = null
    icon = null
    background = null
    background_mobile = null
    banner = null
    banner_title = null
    color = null
    iconZoom = null
    favicon = null

    constructor(logo, icon, favicon, background, background_mobile, banner, banner_title, color, iconZoom) {
        this.logo = logo
        this.icon = icon
        this.favicon = favicon
        this.background = background
        this.background_mobile = background_mobile
        this.banner = banner
        this.banner_title = banner_title
        this.color = color
        this.iconZoom = iconZoom
    }
}